import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import MinimalFooter from "@components/MinimalFooter";
import MinimalHeader from "@components/MinimalHeader";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { PropsWithChildren } from "react";
const Layout = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    partner
  } = usePartnerContext();
  let t1;
  if ($[0] !== partner) {
    t1 = <MinimalHeader border={true} partner={partner} />;
    $[0] = partner;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <Container padding={true} className="grow flex justify-center m:items-center">{children}</Container>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !!partner;
  let t4;
  if ($[4] !== t3) {
    t4 = <MinimalFooter isFullWidth={true} isPartner={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <div className="flex flex-col min-h-screen m:bg-gradient-to-tl from-neutral-50 to-neutral-12">{t1}{t2}{t4}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default Layout;